<template>
  <div class="act-cards fade-up" style="transition-delay:0.12s">
    <div class="act-card" v-for="(card, index) in cardList" :key="'card' + index">
      <ActCard :card-obj="card" :img-url-prefix="imgUrlPrefix" :user-head-prefix="userHeadPrefix"></ActCard>
    </div>
  </div>
</template>

<script>
import ActCard from './ActCard.vue'
export default {
  name: 'ActCardList',
  components: {
    ActCard
  },
  props: {
    cardList: {
      type: Array,
      required: true
    },
    imgUrlPrefix: {
      type: String,
      required: true
    },
    userHeadPrefix: {
      type: String,
      required: true
    }
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.act-cards {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  display: flex;
  gap: 16px;
  padding-bottom: 16px;
  scrollbar-width: none;
  &::-webkit-scrollbar { display: none; }
  .act-card {
    flex-shrink: 0;
    width: 260px;
    cursor: pointer;
    transition: transform 0.2s;
    &:hover {
      transform: translateY(-3px);
    }
    
  }
}
</style>